import type { FieldError } from 'react-hook-form';
import { getAuthPasswordRequirementsMessage } from 'common/constants/auth';
import { getVisibleFieldErrorMessage } from './fieldErrors';

type GetAuthPasswordFieldHelperTextOptions = {
  error?: FieldError;
  hiddenErrorTypes?: readonly string[];
  password?: string;
};

export const getAuthPasswordFieldHelperText = ({
  error,
  hiddenErrorTypes = [],
  password,
}: GetAuthPasswordFieldHelperTextOptions) => {
  const visibleFieldErrorMessage = getVisibleFieldErrorMessage({
    error,
    hiddenErrorTypes,
  });

  if (!visibleFieldErrorMessage) {
    return undefined;
  }

  if (!password) {
    return visibleFieldErrorMessage;
  }

  return getAuthPasswordRequirementsMessage(password) ?? visibleFieldErrorMessage;
};
